import {RouteObject} from 'react-router-dom';
import {ROUTES} from '../routes';
import {
  RepairDocumentCreate,
  RepairDocumentUpdate,
} from './repair-document-create-update';
import {RepairDocumentsListing} from './repair-documents-listing';

export const RepairDocumentsRoutes: RouteObject = {
  path: ROUTES.ADMIN.REPAIR_DOCUMENTS.path,
  children: [
    {
      path: ROUTES.ADMIN.REPAIR_DOCUMENTS.INDEX.path,
      element: <RepairDocumentsListing />,
    },
    {
      path: ROUTES.ADMIN.REPAIR_DOCUMENTS.CREATE.path,
      element: <RepairDocumentCreate />,
    },
    {
      path: ROUTES.ADMIN.REPAIR_DOCUMENTS.DETAIL.path,
      element: <RepairDocumentUpdate />,
    },
  ],
};
